export default __webpack_public_path__ + "static/media/c_3.dcb40951.jpg";